import React from 'react';
import Projects from './Projects';
import "./projects.css";
import { FaWhatsapp } from "react-icons/fa";

const Portfolio = () => {
  return (
    <section className="portfolio section" id="portfolio">
        <h2 className="section__title">الكورسات</h2>
        <span className="section__subtitle">اللهم علمنا ما ينفعنا و انفعنا بما علمتنا 🤍</span>

        <Projects />
      <div style={{display:"flex" , justifyContent:"center" , alignItems:"center", marginTop:"2rem"}}>
        <a  href="https://wa.me/+201272485059" className="button button--flex">
          احصل علي الكود <FaWhatsapp  className="yout"/>
        </a>
        </div>
    </section>
  );
}

export default Portfolio;